import Smooch from 'gladlyinc';
import xhr from 'xhr';

import ConfigurationGateway from 'adapters/gateways/ConfigurationGateway';
import CookieAdapter from 'infrastructure/CookieAdapter';
import JsonpAdapter from 'infrastructure/JsonpAdapter';
import SelfServiceGateway from 'adapters/gateways/SelfServiceGateway';
import SmoochChatGateway from 'adapters/gateways/SmoochChatGateway';
import SmoochMessageGateway from 'adapters/gateways/SmoochMessageGateway';
import SmoochSessionStorage from 'adapters/gateways/SmoochSessionStorage';

export default function({ appId, appEnv, cdn, provider }) {
  let cookie = new CookieAdapter();
  let chatGateway;
  let messageGateway;

  if (provider === 'SMOOCH') {
    let sessionStorage = new SmoochSessionStorage();
    chatGateway = new SmoochChatGateway(Smooch, xhr, sessionStorage);
    messageGateway = new SmoochMessageGateway(Smooch, sessionStorage);
  } else {
    throw new Error(`unrecognized chat provider: ${provider}`);
  }

  return {
    chatGateway,
    messageGateway,
    configurationGateway: new ConfigurationGateway({ appId, cdn, cookie }),
    selfServiceGateway: new SelfServiceGateway({ xhr }),
  };
}
